import { httpInterceptor } from '../http-interceptor';

export class StatusService {
  static ENDPOINTS = {
    GET_ALL: 'status/getallshipmentstatus',
    CREATE: 'customer/create',
    UPDATE: 'customer/update',
    DELETE: 'customer/delete',
    GET_BY_ID: 'customer/getbyid',
    GET_ALL_PROCESS: 'status/getallprocessstatus',
  };

  static async getAllStatuses() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async getShipmentById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async createShipment(shipmentData) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, shipmentData);
  }

  static async updateShipment(id, shipmentData) {
    return httpInterceptor.put(`${this.ENDPOINTS.UPDATE}/${id}`, shipmentData);
  }

  static async deleteShipment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async getAllProcessStatuses() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_PROCESS);
  }
}
